<template lang='pug'>
.introduceDownload-container()
    .left(@click="jump") {{name}}
    .right-container
        .shoucang-container(v-if="type=='shoucang'")
            .shoucang(@click="shoucang" v-if="result" ) 已收藏
            .shoucang(@click="shoucang" v-if="!result") 收藏
        .shoucang(v-if="type!='shoucang'" @click="jump") 查看
        .email(@click="email()") 发送邮箱
</template>

<script>
import {addBookmark,checkMember,deleteBookmark} from '@/service/member'
import { mapState } from 'vuex'
export default {
    props:['name','link','type','id','hId']
,
    data(){
        return {
            show:false,
            mail:'',
            data:[],
            result:false,
        }
    },
    methods:{
        jump(){
            // this.$router.push(`/pdfView?link=${this.link}&name=${this.name}`)
            this.$router.push({
                name: 'pdfView',
                params:{
                    rId:this.id,
                    hId: this.hId
                },
            })
        },
        async email() {
            const {VUE_APP_MEMBER_FORMID,VUE_APP_FORM} =window.env
            let isMember =await checkMember(true)
            if(!isMember){
                window.location.href=`${VUE_APP_FORM}${VUE_APP_MEMBER_FORMID}?redirect=${encodeURIComponent(window.location.href)}`
            }else{
                window.location.href=`${window.env.VUE_APP_SEND_EMAIL}?c_fileurl=${encodeURIComponent(this.link)}&c_filename=${this.name}&redirect=${encodeURIComponent(window.location.href)}` 
            }
                
        },
        sending() {
            this.show=false
        },
        async shoucang(){
            const {VUE_APP_MEMBER_FORMID,VUE_APP_FORM} =window.env
            let isMember =await checkMember(true)
            if(!isMember){
               window.location.href=`${VUE_APP_FORM}${VUE_APP_MEMBER_FORMID}?redirect=${encodeURIComponent(window.location.href)}`
            }
            if(this.result){
                await deleteBookmark(this.result.id)
                await this.$store.dispatch('getBookmarks',true)
                this.data=this.$store.state.bookMarks
                await this.initData()
            }else{
                await addBookmark({
                    detail:{
                        type:'data',
                        name:this.name,
                        link:this.link
                    },
                    name: this.name,
                    url: window.location.href
                })
                await this.$store.dispatch('getBookmarks',true)
                this.data=this.$store.state.bookMarks
                await this.initData()

            }
        },
        async initData(){
            this.download=[]
            this.data.forEach(val=>{
                if(val.detail.type=='data'){
                    this.download.push(val)
                }
            })
            this.result=this.download.find(val=>{
                return val.detail.name==this.name
            })
        }
    },
    computed:{
        ...mapState(['userInfo','memberInfo','bookMarks'])
    },
    async created() {
            if(this.bookMarks){
                this.data=this.bookMarks
                await this.initData()
            }
           
    }
}
</script>

<style scoped lang='less'>
/deep/.van-overlay{
    background: none;
}
/deep/.van-dialog{
    width: 10.75rem;
    height: 6.5rem;
    background: #ffffff;
    border-radius: 0.2rem;
    box-shadow: 0rem 0rem 0.1rem 0rem rgba(0,0,0,0.50); 
}
.introduceDownload-container{
    .dialog{
        input{
            padding:0;
            font-size:0.55rem;
            color:#222222;
            margin-bottom:0.8rem;
            padding-left:0.4rem;
        }
        .title{
            font-size: 0.55rem;
            color: #07448a;
            text-align: center;
            line-height: 0.8rem;
            margin-top:0.7rem;
            margin-bottom: 0.7rem;;
        }
        
        .box-container{
            padding-left:0.6rem;
            padding-right:0.6rem;
            .box{
            width:100%;
            height: 1.6rem;
            background: #ffffff;
            border: 0.05rem solid #e3e3e3;
            border-radius: 0.2rem;
        }
        }
        .send-container{
            padding:0 4rem;
            .send{
            width: 2.8rem;
            height: 1.2rem;
            background: #219cdc;
            border-radius: 0.2rem;
            color: #ffffff;
            font-size: 0.55rem;
            border:none;
        }
        }
        
    }
    background: #f3f3f3;
    border-radius: 0.2rem;
    width:100%;
    padding:0.4rem 0.5rem 0.4rem 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left{
        font-size:0.6rem;
        color:#07448a;
        width: 60%;
    }
    .right-container{
        display: flex;
        .shoucang,.email{
            color: #219cdc;
            font-size:0.6rem;
        }
        .email{
            margin-left:0.6rem
        }
    }
}
.shoucang-container{
    display: flex;
}
</style>